"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var logistics = _interopRequireWildcard(require("@/api/logistics.js"));
var _permission = require("@/utils/permission");
var _public = require("@/libs/public");
var _creatExpress = _interopRequireDefault(require("./creatExpress.vue"));
var _useOrder = require("@/hooks/use-order");
var _validate = require("@/utils/validate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'ShippingTemplates',
  components: {
    CreatExpress: _creatExpress.default
  },
  data: function data() {
    return {
      form: {
        keywords: '',
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      tableData: {
        data: [],
        total: 0
      },
      loading: false,
      expressAllList: [],
      datekey: 0,
      dialogVisible: false,
      formData: {
        status: false,
        sort: 0
      },
      isCreate: 0,
      editId: 0,
      rules: {
        sort: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }],
        account: [{
          required: true,
          message: '请输入月结账号',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入月结密码',
          trigger: 'blur'
        }],
        netName: [{
          required: true,
          message: '请输入网点名称',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['merchant:express:search:page'])) this.getDataList(1);
    if (!localStorage.getItem('expressAllList')) this.getExpressList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 物流公司列表
    getExpressList: function () {
      var _getExpressList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _useOrder.useLogisticsAllList)();
            case 1:
              this.expressAllList = _context.v;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getExpressList() {
        return _getExpressList.apply(this, arguments);
      }
      return getExpressList;
    }(),
    // 添加
    handleCreat: function handleCreat() {
      this.datekey = +new Date();
      //this.$refs.craetExpressRef.dialogVisible = true;
    },
    // 分页
    pageChange: function pageChange(e) {
      this.page = e;
      this.getDataList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.limit = e;
      this.getDataList();
    },
    //修改状态
    handleStatusChange: function handleStatusChange(row) {
      var _this = this;
      logistics.expressOpenSwitchApi(row.id).then(function (res) {
        _this.$message.success('更新状态成功');
        _this.getDataList();
      });
    },
    // 数据列表
    getDataList: function getDataList(num) {
      var _this2 = this;
      this.loading = true;
      this.form.page = num ? num : this.form.page;
      logistics.expressPageApi({
        keywords: encodeURIComponent(this.form.keywords),
        page: this.form.page,
        limit: this.form.limit
      }).then(function (res) {
        _this2.loading = false;
        _this2.tableData.data = res.list;
        _this2.tableData.total = res.total;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 默认操作
    handleSetDefault: function handleSetDefault(item) {
      var _this3 = this;
      logistics.expressDefaultAwitchApi(item.id).then(function (res) {
        _this3.$message.success('操作成功');
        _this3.getDataList(1);
      });
    },
    // 删除
    handleDelete: function handleDelete(item) {
      var _this4 = this;
      this.$modalSure('确定要删除此物流公司吗？').then(function () {
        logistics.expressDeleteApi(item.id).then(function (res) {
          _this4.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this4.tableData.data.length, _this4.form);
          _this4.getDataList();
        });
      });
    },
    //  关闭模态框
    handleClose: function handleClose(done) {
      // this.formData = {}
      // this.formConf.fields = [];
      this.dialogVisible = false;
      this.isCreate = 0;
    },
    // 编辑
    bindEdit: function bindEdit(item) {
      this.dialogVisible = true;
      this.editId = item.id;
      this.formData = item;
    },
    submit: (0, _validate.Debounce)(function (formName) {
      var _this5 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          logistics.expressUpdate(_this5.formData).then(function (res) {
            _this5.$message.success('操作成功');
            _this5.handleClose();
            _this5.getExpressList();
          });
        } else {
          return false;
        }
      });
    })
  }
};